export const TITLE = "Section Status";
export const SUBTITLE = "Section completion by proposal";
export const EMPTY_TITLE = "No proposal sections yet";
export const EMPTY_BODY =
  "As proposal outlines are created and their sections are worked on, progress appears here.";
export const PROPOSALS_LIST_PATH = "/proposals/kanban/list";
export const VISIBLE_PROPOSAL_COUNT = 4;
export const NO_DUE_DATE = "-";

export const SECTION_STATUS_ORDER = ["complete", "inReview", "drafting", "notStarted"];

export const SECTION_STATUS_LABELS = {
  complete: "Complete",
  inReview: "In Review",
  drafting: "Drafting",
  notStarted: "Not Started",
};

export const SECTION_STATUS_COLORS = {
  complete: "var(--color-middle-green)",
  inReview: "var(--color-middle-blue)",
  drafting: "var(--color-middle-orange)",
  notStarted: "var(--color-middle-gray)",
};
